export class ApiUrls {
  static TRAVEL_ME_URL = process.env.REACT_APP_TRAVEL_ME_PARIS_URL;
  static TRAVEL_ME_CONTACT = ApiUrls.TRAVEL_ME_URL + "questions-frequentes";
  static domain = process.env.REACT_APP_BACKEND_URL || process.env.REACT_APP_BASE_URL;

  private static normalizeUrl(value?: string) {
    if (!value) {
      return "";
    }

    return value.endsWith("/") ? value.slice(0, -1) : value;
  }

  // Normaliser le backend pour éviter les doubles slashes.
  static baseUrl = `${ApiUrls.normalizeUrl(ApiUrls.domain)}/api/`;
  static loginUrl = ApiUrls.baseUrl + "auth/jwt/create/";
  static refreshTokenUrl = ApiUrls.baseUrl + "auth/jwt/refresh/";
  static currentUserUrl = ApiUrls.baseUrl + "users/me/";
  static visitListUrl = (page: any, limit: any) =>
    ApiUrls.baseUrl + `visits/?page=${page}&page_size=${limit}`;
  static visitsHistoryUrl = (from?: string) =>
    ApiUrls.baseUrl + `visits/?status=completed,no_show&page_size=200${from ? `&from=${from}` : ""}`;
  static visitDetailUrl = (id: any) =>
    ApiUrls.baseUrl + `visits/${id}/`;
  static unAuthUserVisitDetailUrl = (id: any) =>
    // Trailing slash matters: without it Django 301-redirects, and browsers
    // cache that permanent redirect (a CORS-header-less cached 301 kills the
    // XHR for good).
    ApiUrls.baseUrl + `visits/details/?visit=${id}`;
  static adminvisitDetailUrl = (id: any, limit: any, page: any) =>
    ApiUrls.baseUrl + `visits/${id}/?page=${page}&page_size=${limit}`;
  static UniqueIdGenerator = ApiUrls.baseUrl + "utils/generate-unique-id";
  static UserDetails = (visit_id: any, user_id: any) =>
    ApiUrls.baseUrl +
    `visits/${visit_id}/?user_id=${user_id}`;
  static Waitinglist = (visit_id: any) =>
    ApiUrls.baseUrl + `visits/participants/waiting/?visit_id=${visit_id}`;
  static Particiapntdetails = ApiUrls.baseUrl + `visits/participants/`;
  static AgoraUrl = ApiUrls.baseUrl + "externe_api/agora/";
  static publicAgoraUrl = ApiUrls.baseUrl + "externe_api/agora/public/";
  static feedbackUrl = process.env.REACT_APP_FEEDBACK_SHEET_URL;
  static agoraVideoResolution = ApiUrls.baseUrl + "externe_api/agora/";
  static publicAgoraVideoResolution = ApiUrls.baseUrl + "externe_api/agora/public/";
  static channelUrl = process.env.REACT_APP_FRONTEND_URL + "visit/";
  static frontendUrl = process.env.REACT_APP_FRONTEND_URL;
}
